<template>
	<WarningChip
		v-if="isOverdue"
		class-name="commitment-due-date-picker__chip"
		:text="displayDateValue"
		@click="$emit( 'click', $event )"
	/>
	<DueChip
		v-else-if="showDueDateChip"
		class-name="commitment-due-date-picker__chip"
		:text="displayDateValue"
		@click="$emit( 'click', $event )"
	/>
	<div v-else>
		<TeamingButton
			type="QUATERNARY"
			size="SMALL"
			:leftIcon="['far', 'calendar-plus']"
			class="commitment-due-date-picker__button"
			@buttonPress="$emit( 'click', $event )"
		/>
	</div>
</template>

<script>
import moment from "moment-timezone";
import WarningChip from "../WarningChip";
import DueChip from "../DueChip";
import TeamingButton from "../buttons/TeamingButton.vue";

export default {
	name: "CommitmentDueDatePicker",

	emits: [ "click", ],

	components: {
		DueChip,
		TeamingButton,
		WarningChip,
	},

	props: {
		due: {
			type: Date,
			default: undefined,
		},
		completed: {
			type: Date,
			default: undefined,
		},
	},

	computed: {
		showDueDateChip() {
			return !!this.due;
		},
		isOverdue() {
			/*
				For completed Action Items:
				- If it was completed on or before the Due Date, the icon should remain blue
				- If it was completed after the Due date the red warning indicator would be shown.
			*/
			if ( this.completed ) {
				const endOfDayDueDate = moment( this.due ).endOf( "day" );
				return moment( this.completed ).isAfter( endOfDayDueDate );
			}

			return this.due && moment( new Date( this.due ) ).endOf( "day" ).isBefore( moment() );
		},
		displayDateValue() {
			return this.due ?
				moment( this.due ).format( "MMM DD" ) :
				undefined;
		},
	},
};
</script>

<style lang="scss">
.commitment-due-date-picker {
	.teamingButton {
		height: 1.375rem;
		width: 1.375rem;
		padding-left: 0.4rem;
		padding-right: 0.4rem;
		border-radius: 0.25rem;
	}
}
</style>

<style lang="scss" scoped>
.commitment-due-date-picker__chip {
	white-space: nowrap;
	cursor: pointer;
	min-width: 4.1rem;
}

.commitment-due-date-picker__button {
	height: 1.5rem;
	width: 1.5rem;
	padding-left: 0.4rem;
	padding-right: 0.4rem;
	border-radius: 0.25rem;
}
</style>
